import * as FullStory from '@fullstory/browser';
import * as Sentry from '@sentry/browser';
import { USER_CONTINENT, USER_COUNTRY } from './constants';

// Retry function to help reduce the frequency of chunk load issues occurring and the instances recorded in Sentry.
// eslint-disable-next-line import/prefer-default-export
export const retry = (fn: any, retriesLeft = 5, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: any) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export const getUserCountry = (): string => sessionStorage.getItem(USER_COUNTRY) || 'AU';

export const getUserContinent = (): string | null => sessionStorage.getItem(USER_CONTINENT);

export function captureExceptionWithFullyStory(error: Error, extra?: Record<string, any>): void {
  if (!window.isHeadless) {
    Sentry.setTag('FS Session', FullStory.getCurrentSessionURL(true));
  }
  Sentry.captureException(
    error,
    extra && {
      extra,
    },
  );
}
